/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftEndMutationResponse, PostApiBarberShiftEnd400, PostApiBarberShiftEnd401, PostApiBarberShiftEnd403, PostApiBarberShiftEnd404, PostApiBarberShiftEnd500 } from "../entities/PostApiBarberShiftEnd";

function getPostApiBarberShiftEndUrl() {
  const res = { method: 'POST', url: `/api/barber/shift/end` as const }
  return res
}

/**
 * @description Мастер завершает рабочую смену
 * @summary Завершить смену
 * {@link /api/barber/shift/end}
 */
export async function postApiBarberShiftEnd(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiBarberShiftEndMutationResponse, ResponseErrorConfig<PostApiBarberShiftEnd400 | PostApiBarberShiftEnd401 | PostApiBarberShiftEnd403 | PostApiBarberShiftEnd404 | PostApiBarberShiftEnd500>, unknown>({ method : "POST", url : getPostApiBarberShiftEndUrl().url.toString(), ... requestConfig })
  return res.data
}